<template>
  <div class="approve-application-form-block">
    <sign-modal
        :application="form.application"
        :organization="form.organization"
        :cert-list-box-id="certListBoxId"
        :current-action="currentAction"
        :signer="this.signers[this.form.application.id]"
        :modal-id="signModalId"
        :sign-and-approve-command="signAndApproveCommand"
        @show="onShowModal"
        ref="modal"
    />
    <slot name="before"></slot>
    <div class="row" style="margin-bottom: 16px">
      <div class="col-md-12">
        <p>
          Заявка на {{ form.visitors.length }}
          {{ countVisitorsDeclension }}.
          <template v-if="visibleClosedVisitors">
            Из них одобрено:
            {{ form.visitors.length - approveForm.visitors.length }}, отклонено:
            {{ approveForm.visitors.length }}
          </template>
        </p>
      </div>
    </div>
    <div class="row">
      <div :class="classCommentBlock" v-if="visibleCommentBlock">
        <input
          type="text"
          class="form-control"
          placeholder="Комментарий"
          v-model="form.application.comment"
          :disabled="disabledCommentInput"
        />
      </div>
    </div>
    <div class="row" style="margin-top: 20px" v-if="visibleApproveButtonsBlock">
      <span style="padding-left: 15px" class="approve-buttons" v-for="action in statusActions" :key="action.alias">
        <button
            type="button"
            style="border-radius: 8px"
            class="btn btn-default"
            v-on:click="action.esignature === '1' ? getSigner(form.application, action) : approvalCommand(form.application, action)"
        >
          <img v-if="action.icon !== 'default.svg'" :src="iconsPath + action.icon" width="20px" height="22px" alt=""/>
          {{ action.command_name }}
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import { ApplicationStatuses } from '@/common/enums/ApplicationStatuses'
import approveFormContextMixin from '@/common/mixins/approveFormContextMixin'
import { declOfNum } from '@/common/helpers'
import loadCadesplugin from '@/common/helpers/signer/cadesplugin_api.js'
import { Logger } from '@/common/helpers/Logger'
import mainMixin from '@/common/mixins/mainMixin'
import { ResponseStatuses } from '@/common/enums/ResponseStatuses'
import { Signer } from '@/common/helpers/signer/signer'
import SignModal from '@/common/components/application/form-blocks/SignModal.vue'
import { UserRoles } from '@/common/enums/UserRoles'

export default {
  name: 'ApproveApplicationFormBlock',
  mixins: [
    mainMixin,
    applicationFormMixin,
    applicationFormContextMixin,
    approveFormContextMixin
  ],

  components: {
    SignModal
  },

  data: () => ({
    signers: {},
    showSignerModal: false,
    currentAction: null,
    actions: null
  }),

  props: {
    form: Object,
    getSigner: Function,
    approvalCommand: Function,
    statusActions: {
      default: () => ({})
    }
  },

  computed: {
    certListBoxId () {
      return `certListBox-${this.form.application.id}`
    },

    signModalId () {
      return `modal-border-${this.form.application.id}`
    },

    canSign () {
      return this.user && [
        UserRoles.PNT,
        UserRoles.SB,
        UserRoles.SB_OTHER,
        UserRoles.SB_TRUCK,
        UserRoles.SUBDIVISION
      ].includes(this.user.role)
    },

    countVisitorsDeclension () {
      return declOfNum(this.form.visitors.length, [
        'посетителя',
        'посетителей',
        'посетителей'
      ])
    },

    visibleClosedVisitors () {
      return (
        this.user &&
        [UserRoles.SB, UserRoles.SB_TRUCK, UserRoles.SB_OTHER].includes(
          this.user.role
        ) &&
        this.form.application.status !== ApplicationStatuses.SUBDIVISION_YES
      )
    },

    classKppBlock () {
      return 'col-md-4'
    },

    visibleKppBlock () {
      return [
        ApplicationStatuses.SB_YES,
        ApplicationStatuses.FSB_BEGIN,
        ApplicationStatuses.SB_NO,
        ApplicationStatuses.FSB_NO,
        ApplicationStatuses.KTSP,
        ApplicationStatuses.FSB_YES
      ].includes(this.form.application.status)
    },

    disabledKppInput () {
      return [
        ApplicationStatuses.FSB_NO,
        ApplicationStatuses.SB_NO,
        ApplicationStatuses.KTSP,
        ApplicationStatuses.FSB_YES,
        ApplicationStatuses.FSB_BEGIN
      ].includes(this.form.application.status)
    },

    classCommentBlock () {
      return 'col-md-12'
    },

    visibleCommentBlock () {
      if (this.user.role === UserRoles.USER && this.form.application.comment) {
        return true;
      }

      return ![ApplicationStatuses.DRAFT].includes(this.form.application.status);
    },

    disabledCommentInput () {
      return [
        ApplicationStatuses.FSB_NO,
        ApplicationStatuses.SB_NO,
        ApplicationStatuses.FSB_YES,
        ApplicationStatuses.FSB_BEGIN
      ].includes(this.form.application.status) || this.statusActions.length === 0 || this.user.role === UserRoles.USER
    },

    visibleApproveButtonsBlock () {
      return this.statusActions
    },

    disableApproveButton () {
      return (
        this.approveForm.sending ||
          this.form.visitors.length === this.approveForm.visitors.length
      )
    },

    disableRejectButton () {
      return this.approveForm.sending
    },

    equalSubdivisions () {
      let applicationSubdivisionId = this.form.application.subdivision_id
      if (![null, undefined].includes(applicationSubdivisionId)) {
        applicationSubdivisionId = parseInt(applicationSubdivisionId)
      }

      return Boolean(this.user.subdivisions.find(subdivisionId => parseInt(subdivisionId) === applicationSubdivisionId))
    },

    iconsPath () {
      return process.env.BASE_URL + '/img/icons/statuses/'
    }
  },

  async created () {
    loadCadesplugin()
  },

  methods: {
    approveApplicationCommand (action) {
      this.currentAction = action
      this.signers[this.form.application.id] = new Signer({
        requestHashUrl: ApiClient.getSignerStepOneUrl(this.form.application),
        sendSignatureUrl: ApiClient.getSignerStepTwoUrl(this.form.application),
        certListBoxId: this.certListBoxId,
        statusSettings: action
      })

      if (Boolean(Number(action.esignature)) === true) {
        this.$bvModal.show(this.signModalId);
        const html = document.getElementsByTagName('html')[0]
        html.classList.add('html-modal-open')
      } else {
        this.approveCommand()
      }
    },

    async sendCheck (status, signer = false) {
      let signResult = null
      let signSuccess = false

      this.approveForm.sending = true

      try {
        if (signer) {
          const sign = this.signers[Number(this.form.application.id)]
          signResult = await sign.sign()
          signSuccess = true
        }

        if (!signer || (signer && signSuccess && signResult)) {
          await ApiClient.approveApplication({
            data: {
              application_id: this.form.application.id,
              status: Boolean(status),
              edit: this.form.application.edit,
              blockedVisitors: this.approveForm.visitors,
              visitors: this.form.visitors,
              comment: this.form.application.comment,
              kpp: this.form.application.kpp
            }
          }).then((response) => {
            const result = response.data

            if (result.message.length > 0) {
              alert(result.message)
            }

            if (result.status === ResponseStatuses.Success) {
              if (result.data && result.data.app_status) {
                Logger.log(`New application status: ${result.data.app_status}`)
              }

              window.location.href = ApiClient.getApplicationScreenUrl()
            }
          })
        }
      } catch (error) {
        Logger.log(error)

        if (signer) {
          alert('При подписании возникла ошибка')
        } else {
          alert('При согласовании заявки возникла клиентская ошибка')
        }
      }

      this.approveForm.sending = false
    },

    onShowModal () {
      const signer = this.signers[Number(this.form.application.id)]

      if (window.cadesplugin) {
        window.cadesplugin.then(function () {
          signer.requestCertificates()
        })
      }
    },

    async signAndApproveCommand () {
      let result = await this.signers[this.form.application.id].sign();

      if (result) {
        await this.approveCommand()
      }
    },

    async approveCommand () {
      let success = false;

      await ApiClient.updateStatus(this.form.application.id, { alias: this.currentAction.alias })
        .then(function (response) {
          if (response.status === 204) {
            success = true
          }
        })
        .catch(function (error) {
          console.log(error.response)
          alert(error.response.data?.error);
          this.$refs.modal.unsetPreload()

          success = false
        })
        .finally(function () {
          if (success === true) {
            setTimeout(
              function () {
                window.location.reload()
              }, 1000);
          }
        });
    }
  }
}
</script>
